import { HistoryDataValue, HistoryDataModel } from '@flexem/fc-gui';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
var SimulateHistoryDataStore = /** @class */ (function () {
    function SimulateHistoryDataStore() {
    }
    SimulateHistoryDataStore.prototype.getHistoryData = function (args) {
        var mockedValues = new Array();
        if (args.channelNames && args.channelNames.length) {
            var channelsCount = args.channelNames.length;
            for (var i = 0; i < 60; i++) {
                var duration = args.limit > 0 ? i : -i;
                var mockedData = new HistoryDataValue(args.startTime.clone().add(duration, 's'), []);
                for (var j = 0; j < channelsCount; j++) {
                    mockedData.values.push(Math.floor(Math.random() * 100));
                }
                mockedValues.push(mockedData);
            }
        }
        return of(new HistoryDataModel(null, false, mockedValues)).pipe(delay(2000));
    };
    return SimulateHistoryDataStore;
}());
export { SimulateHistoryDataStore };
